/**
 * Extract the blog base path from a tenant's featureConfig JSON string.
 * Returns the configured path or "/legal-insights" as default.
 */
export function parseBlogBasePath(
  featureConfigJson: string | null | undefined,
): string {
  if (!featureConfigJson) return "/legal-insights";
  try {
    const parsed = JSON.parse(featureConfigJson);
    return parsed?.blog?.path || "/legal-insights";
  } catch {
    return "/legal-insights";
  }
}
